import React, { Fragment } from "react";

import Footer from "../components/footer";
import Nav from "../components/nav";

const MPage = (props) => {
  const { logo, nombre, nombreUrl } = props.municipio;
  return (
    <Fragment>
      <a className="skip-link" href="#contenido">
        Saltar al contenido
      </a>
      <Nav logo={logo} nombre={nombre} nombreUrl={nombreUrl} />
      <main id="contenido" className="container main-container">
        <div className="row">
          <div className="col-md-12">{props.children}</div>
        </div>
      </main>
      <Footer />
    </Fragment>
  );
};

export default MPage;
